var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggler-lang__container",on:{"click":_vm.toggleLang,"keyup":_vm.toggleLang}},[_c('IconLang'),_c('p',{staticClass:"toggler-lang__container-text"},[_vm._v(" "+_vm._s(_vm.$i18n.locale.toUpperCase())+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }